import {
  Compass,
  Eye,
  Filter,
  Frown,
  Image as ImageIcon,
  Layers,
  Lightbulb,
  ListChecks,
  Megaphone,
  MessagesSquare,
  MousePointerClick,
  Package,
  PanelTop,
  Quote,
  Shapes,
  ShoppingBag,
  Store,
  Tag,
  Users,
} from "lucide-react";

import { TestedAssetType } from "@digital-twins/shared-types";

/**
 * Shared look of the report hero facts: audience, study type, asset count,
 * and the Filtered marker. 12px semibold, heading ink, 14px icon.
 */
export const eyebrowItemClass =
  "inline-flex items-center gap-1.5 text-xs font-semibold leading-none text-[hsl(var(--report-heading))]";

export const eyebrowIconClass = "h-3.5 w-3.5 shrink-0";

export const AudienceIcon = Users;
export const FilteredIcon = Filter;

const STUDY_TYPE_ICONS = {
  explore: { Icon: Compass, name: "compass" },
  lp_conversion: { Icon: MousePointerClick, name: "mouse-pointer-click" },
  ad_creative: { Icon: Megaphone, name: "megaphone" },
  concept_validation: { Icon: Lightbulb, name: "lightbulb" },
  pricing_packaging: { Icon: Tag, name: "tag" },
  brand_perception: { Icon: Eye, name: "eye" },
  claim_validation: { Icon: MessagesSquare, name: "messages-square" },
  pain_ranking: { Icon: ListChecks, name: "list-checks" },
};

const ASSET_ICONS = {
  message: { Icon: Quote, name: "quote" },
  ad: { Icon: ImageIcon, name: "image" },
  landing_page: { Icon: PanelTop, name: "panel-top" },
  concept: { Icon: Shapes, name: "shapes" },
  product: { Icon: ShoppingBag, name: "shopping-bag" },
  packaging: { Icon: Package, name: "package" },
  brand: { Icon: Store, name: "store" },
  pain: { Icon: Frown, name: "frown" },
  assets: { Icon: Layers, name: "layers" },
};

export function studyTypeIcon(goalId: string) {
  if (!(goalId in STUDY_TYPE_ICONS)) {
    return null;
  }
  return STUDY_TYPE_ICONS[goalId as keyof typeof STUDY_TYPE_ICONS];
}

export function assetEyebrowIcon(type: TestedAssetType | null) {
  if (type && type in ASSET_ICONS) {
    return ASSET_ICONS[type];
  }
  return ASSET_ICONS.assets;
}
